import { render } from "./ClampContent.vue?vue&type=template&id=eb3cf8d0&lang=pug"
import script from "./ClampContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ClampContent.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__